import React from 'react';
import { useAuth } from 'hook/auth';
import { useHistory } from 'react-router-dom';
import LoginCarousel from './component/carousel';
import LoginForm from './component/form';
const logoTemporary = require('asset/image/logo.png');

export default function LoginPage() {
  const history = useHistory();
  const { loading, error, isAuth, login } = useAuth();

  React.useEffect(() => {
    if (isAuth) {
      history.replace('/inicio');
    }
  }, [isAuth]);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Carrossel - escondido em telas menores que md */}
      <div className="hidden md:flex w-1/2 items-center justify-center bg-primary bg-onboard_bg_img bg-cover bg-center">
        <LoginCarousel />
      </div>

      {/* Formulário */}
      <div className="flex w-full md:w-1/2 items-center justify-center px-6 py-8">
        <div className="w-full max-w-[400px]">
          <img
            alt="Logo"
            src={logoTemporary}
            className="mb-11 h-25 w-full object-contain"
          />
          <LoginForm handleSubmit={login} error={error} loading={loading} />
        </div>
      </div>
    </div>
  );
}
